import styled from 'styled-components'
import { padding } from 'theme/mixins'

const Wrapper = styled.div`
	padding: ${padding('md')} ${padding('lg')} 0 ${padding('sm')};

	img {
		width: 100%;
	}
`

export default { Wrapper }
